module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/accountbranches/accountbranches-show/accountbranches-show.component.scss
// module id = ./src/app/views/fin/accountbranches/accountbranches-show/accountbranches-show.component.scss
// module chunks = main